import { useTranslate } from '@tolgee/react'
import { useExceptionMessageHandler } from '@yard/utils/useExceptionMessageHandler'

export const useYardSetupMessageHandler = () => {
  const { t } = useTranslate()
  const { getExceptionMessage } = useExceptionMessageHandler()

  const getBlockSuccessMessage = (isEditing: boolean) => {
    return isEditing
      ? t('yardBlockUpdatedSuccesfully', 'Yard block updated successfully')
      : t('yardBlockCreatedSuccesfully', 'Yard block created successfully')
  }

  const getFlexibleSuccessMessage = (isEditing: boolean) => {
    return isEditing
      ? t('flexibleBlockUpdatedSuccesfully', 'Flexible block updated successfully')
      : t('flexibleBlockCreatedSuccesfully', 'Flexible block created successfully')
  }

  const getLayoutObjectSuccessMessage = (isEditing: boolean) => {
    return isEditing
      ? t('layoutObjectUpdatedSuccesfully', 'Layout object updated successfully')
      : t('layoutObjectCreatedSuccesfully', 'Layout object created successfully')
  }

  const getGateSuccessMessage = (isEditing: boolean) => {
    return isEditing
      ? t('gateUpdatedSuccesfully', 'Gate updated successfully')
      : t('gateCreatedSuccesfully', 'Gate created successfully')
  }

  const getBerthSuccessMessage = (isEditing: boolean) => {
    return isEditing
      ? t('berthUpdatedSuccesfully', 'Berth updated successfully')
      : t('berthCreatedSuccesfully', 'Berth created successfully')
  }

  const getRailTrackSuccessMessage = (isEditing: boolean) => {
    return isEditing
      ? t('railTrackUpdatedSuccesfully', 'Rail track updated successfully')
      : t('railTrackCreatedSuccesfully', 'Rail track created successfully')
  }

  const getBlockDeleteSuccessMessage = () => {
    return t('yardBlockDeletedSuccesfully', 'Yard block deleted successfully')
  }

  const getFlexibleDeleteSuccessMessage = () => {
    return t('flexibleBlockDeletedSuccesfully', 'Flexible block deleted successfully')
  }

  const getLayoutObjectDeleteSuccessMessage = () => {
    return t('layoutObjectDeletedSuccesfully', 'Layout object deleted successfully')
  }

  const getGateDeleteSuccessMessage = () => {
    return t('gateDeletedSuccesfully', 'Gate deleted successfully')
  }

  const getHoldingPointSuccessMessage = (isEditing: boolean) => {
    return isEditing
      ? t('holdingPointUpdatedSuccessfully', 'Holding point updated successfully')
      : t('holdingPointCreatedSuccessfully', 'Holding point created successfully')
  }

  const getHoldingPointDeleteSuccessMessage = () => {
    return t('holdingPointDeletedSuccessfully', 'Holding point deleted successfully')
  }

  const getHandoverAreaSuccessMessage = (isEditing: boolean) => {
    return isEditing
      ? t('handoverAreaUpdatedSuccessfully', 'Handover area updated successfully')
      : t('handoverAreaCreatedSuccessfully', 'Handover area created successfully')
  }

  const getHandoverAreaDeleteSuccessMessage = () => {
    return t('handoverAreaDeletedSuccessfully', 'Handover area deleted successfully')
  }

  const getBerthDeleteSuccessMessage = () => {
    return t('berthDeletedSuccesfully', 'Berth deleted successfully')
  }

  const getRailTrackDeleteSuccessMessage = () => {
    return t('railTrackDeletedSuccesfully', 'Rail track deleted successfully')
  }

  const getReservationSuccessMessage = () => {
    return t('reservationCreatedSuccesfully', 'Reservation created successfully')
  }

  const getUpdatePositionSuccessMessage = () => {
    return t('updatePositionSuccesfully', 'Position updated successfully')
  }

  return {
    getExceptionMessage,
    getBlockSuccessMessage,
    getBlockDeleteSuccessMessage,
    getFlexibleSuccessMessage,
    getFlexibleDeleteSuccessMessage,
    getLayoutObjectSuccessMessage,
    getLayoutObjectDeleteSuccessMessage,
    getGateSuccessMessage,
    getGateDeleteSuccessMessage,
    getHoldingPointSuccessMessage,
    getHoldingPointDeleteSuccessMessage,
    getHandoverAreaSuccessMessage,
    getHandoverAreaDeleteSuccessMessage,
    getReservationSuccessMessage,
    getBerthSuccessMessage,
    getBerthDeleteSuccessMessage,
    getRailTrackSuccessMessage,
    getRailTrackDeleteSuccessMessage,
    getUpdatePositionSuccessMessage,
  }
}
